import dayjs from 'dayjs'

let options = {
  day: 'numeric',
  month: 'short',
  year: '2-digit',
}

const formatDate = (date) => {
  let FinDate
  if (date === null || date === '' || date === undefined) {
    FinDate = '-'
  } else {
    const dateArray = new Date(date)
      ?.toLocaleString('en-IN', options)
      ?.split(' ')
    FinDate = dateArray?.join('-')
  }

  return FinDate
}

export default formatDate

export const formatDateMonth = (date) => {
  if (date) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' }
    const formattedDate = new Date(date).toLocaleDateString('en-US', options)

    const [month, day, year] = formattedDate.split(' ')
    const capitalizedMonth = month.toUpperCase()

    return `${day} ${capitalizedMonth} ${year}`
  } else return
}

export const formatDateTime = (dateTime) => {
  if (dateTime) {
    return dayjs(dateTime).format('DD MMM YYYY h:mm A')
  }
  return '-'
}

export const formatDateString = (dateString) => {
  if (!dateString) return ''
  return dayjs(dateString).format('YYYY-MM-DD')
}

export const formattedDate = (date) => {
  if (date) {
    return dayjs(date).format('DD MMM YYYY')
  }
  return '-'
}

export const formatTime = (time) => {
  if (time) {
    return dayjs(time).format('h:mm A')
  }
  return '-'
}
